import { Component, OnInit, Inject, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { log } from 'console';
import { OspService } from 'src/app/core/master-services/osp.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { warningMessage } from 'src/app/constants';
import * as moment from 'moment';
import { getUnique, getUniqueByKey, yearWeekToDate } from 'src/app/constants';
import { DeleteBtnCellRender } from 'src/app/configuration-shifts/breaks-detailview/review-changes/review-container.component/delete-btn-cell-render';
import { DeleteBreaksComponent } from 'src/app/configuration-shifts/breaks-detailview/delete-breaks/delete-breaks.component';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogConfig as MatDialogConfig,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';
import { DefaultService } from 'src/app/services/default.service';


@Component({
  selector: 'app-template-stocking-pace-maintenance',
  templateUrl: './template-stocking-pace-maintenance.html',
  styleUrls: ['./template-stocking-pace-maintenance.scss']
})
export class TemplateStockingPaceMaintenanceComponent implements OnInit {
  addPartsGroupEventEmitter = new EventEmitter();
  paceDownloadEventEmitter = new EventEmitter();
  rowData = [];
  @ViewChild('osPartsGrid') osPartsGrid;

  gridOptions = {} as any;
  columnDefs;
  defaultColDef;
  rowSelection;
  context: any;
  editType;
  suppressClickEdit = true;
  errorMessage1: any;
  errorMessageUpdate = false;
  master_id: any;
  master_name: any;
  key_item: any;
  data_item: any;
  business_entity: any;
  new_key_item: any;
  cstatus: any;
  showaddpopup: boolean = false;
  showeditpopup: boolean = false;
  dock: any;
  popupname: any;
  groupName: any;
  countCycle:any;
  dayWeek: any;
  inNextDay: any;
  dataItem: any;
  enableError: boolean = false;
  userForm: UntypedFormGroup;
  shiftNumbers: any[] = [];
  errorMessage: any;
  selectedrenbanFrom : any;
  selectedrenbanTo : any;
  selectedDock: any;
  filteredRenbanList: any = [];
  addOrEditform: UntypedFormGroup = this.formBuilder.group({
    dock: ['', Validators.required],
    // groupName: ['', Validators.required],
    // countCycle: ['', Validators.required],
    // selectedDock: ['', Validators.required],
    selectedrenbanFrom: ['', Validators.required],
    selectedrenbanTo: ['', Validators.required],
  },
  );
  warningMessage: string;
  itContact: any;
  successMessage: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogeRef: MatDialogRef<TemplateStockingPaceMaintenanceComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly ospService: OspService,
    private readonly spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private readonly defaultService : DefaultService

  ) {}
  
  get addOrEdit() {
    return this.addOrEditform.controls;
  }
  ngOnInit(): void {
  //  this.onDockChange();
    console.log(this.data.dock,'dockValue')
    this.addOrEditform.controls.dock.setValue(this.data.dock);
    this.business_entity = localStorage.getItem('namcvalue');
   
    console.log("data---", this.data);
    console.log("data---1", this.data.dock);
    this.addOrEditform.patchValue({
      dock: this.addOrEdit.dock.value
    });
    // Initialize with all renban options
    this.filteredRenbanList = this.data.renbanList || [];
    
    // Try to assign default dock after a short delay
    setTimeout(() => {
      this.assignDefaultDock();
    }, 100);
  }
  
  submitted: boolean = false;
  
  addPartsGroupDetails() {
    this.addOrEditform.controls.dock.setValue(this.data.dock);

    if (!this.addOrEditform.valid) {
      this.submitted = true;
      return;
    }
    console.log(this.addOrEdit,'addOrEdit')
    console.log(this.addOrEditform,'addOrEditform')
    const addEmittedData = {
      dock: this.addOrEdit.dock.value.dock,
      groupName: this.addOrEdit.groupName.value,
      countCycle: this.addOrEdit.countCycle.value,
    };
    console.log(addEmittedData,'addEmittedData')
    this.addPartsGroupEventEmitter.emit(addEmittedData);
    this.dialogeRef.close();
  }

  editPartsGroupDetails() {
    console.log(this.addOrEdit,'addOrEdit')
    console.log(this.addOrEditform,'addOrEditform')
    if (this.addOrEditform.invalid) {
      this.submitted = true;
      return;
    }

    const editEmittedData = {
      dock: this.addOrEdit.dock.value.dock,
      selectedrenbanFrom: this.addOrEdit.selectedrenbanFrom.value.container_renban,
      selectedrenbanTo: this.addOrEdit.selectedrenbanTo.value.container_renban,
    };

    console.log(editEmittedData, 'editEmittedData');

    this.paceDownloadEventEmitter.emit(editEmittedData);
  }
  
  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  };

  errorCallback = (error) => {
    console.error(error);
    this.hideSpinner();
    this.removeMessage();
    this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
  };
  hideSpinner() {
    this.spinner.hide();
  }

  callRespectiveFunction() {
    if (this.data?.mode === 'download') {
      this.editPartsGroupDetails();
    } else {
      console.log("add function is called");

      this.addPartsGroupDetails();
    }
  }
 
  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);
    // Allow number keys, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');  
  }
  defaultDock: any
  assignDefaultDock(){
    try {
      if (this.data.dock?.length > 0){
        const defaultdockArray : any[] = JSON.parse(localStorage.getItem('defaultdock') || '[]');
        if (Array.isArray(defaultdockArray)){
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          let defaultDock = this.data.dock.find(item => validDocks.has(item.dock));
          if (defaultDock){
            this.addOrEditform.controls.dock.setValue(defaultDock);
            this.onDockChange();
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      return false;
    }
  }
  
  onDockChange(): void {
    const selectedDock = this.addOrEditform.controls.dock.value;
    
    if (selectedDock?.dock && this.data.filterList) {
      this.filteredRenbanList = this.data.renbanList.filter(item => 
        this.data.filterList.some(filterItem => 
          filterItem.dock === selectedDock.dock && 
          filterItem.container_renban === item.container_renban
        )
      );
    } else {
      this.filteredRenbanList = this.data.renbanList || [];
    }
    
    // Auto-select first and last renban values
    if (this.filteredRenbanList.length > 0) {
      this.addOrEditform.controls.selectedrenbanFrom.setValue(this.filteredRenbanList[0]);
      this.addOrEditform.controls.selectedrenbanTo.setValue(this.filteredRenbanList[this.filteredRenbanList.length - 1]);
    } else {
      this.addOrEditform.controls.selectedrenbanFrom.setValue(null);
      this.addOrEditform.controls.selectedrenbanTo.setValue(null);
    }
    this.defaultService.setDockCode(JSON.stringify([selectedDock]));

  }

}

